/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Overview_CtaInputs */

const en_directory_comparison_overview_cta = /** @type {(inputs: Directory_Comparison_Overview_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Seek AI products`)
};

const zh_directory_comparison_overview_cta = /** @type {(inputs: Directory_Comparison_Overview_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览 Seek AI 产品`)
};

/**
* | output |
* | --- |
* | "Browse Seek AI products" |
*
* @param {Directory_Comparison_Overview_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_overview_cta = /** @type {((inputs?: Directory_Comparison_Overview_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Overview_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_overview_cta(inputs)
	return zh_directory_comparison_overview_cta(inputs)
});
export { directory_comparison_overview_cta as "directory.comparison.overview.cta" }